import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHeaderMedia } from '../../components/NewbuildingHeaderMedia';
import { getIsGenplanAvailable } from '../../selectors/newbuildingHeader';
import { NewbuildingGenplanContainer } from '../NewbuildingGenplan';
import { NewbuildingHeaderSliderContainer } from '../NewbuildingHeaderSlider';
import { NewbuildingMapContainer } from '../NewbuildingMapContainer';

export const NewbuildingHeaderMediaContainer: React.FC = () => {
  const genplanAvailable = useSelector(getIsGenplanAvailable);

  return (
    <NewbuildingHeaderMedia isSingleRow={!genplanAvailable}>
      <NewbuildingHeaderSliderContainer />
      <NewbuildingGenplanContainer />
      <NewbuildingMapContainer />
    </NewbuildingHeaderMedia>
  );
};
